
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home.jsx';
import Services from './pages/Services.jsx';
import Contact from './pages/Contact.jsx';
import AboutUs from './pages/Aboutus.jsx';
import SalonLocation from './pages/SalonLocation.jsx';
import NotFound from './pages/NotFound.jsx';
import PageMeta from './pages/PageMeta.jsx';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <PageMeta
                title="Priyaa's Beauty Salon | Hair, Bridal Makeup & Spa in Perambur, Chennai"
                description="Priyaa's Beauty Salon – Perambur, Chennai. Expert hair styling, bridal makeup, skin care, spa & nail services since 2015. Book your appointment today."
                path="/"
              />
              <Home />
            </>
          }
        />
        <Route
          path="/services"
          element={
            <>
              <PageMeta
                title="Hair, Bridal Makeup, Facial & Spa Services | Priyaa's Beauty Salon"
                description="Beauty services at Priyaa's Beauty Salon, Perambur, Chennai – haircuts & styling, hair colouring, bridal & party makeup, facials, skin care, spa, hand & feet care."
                path="/services"
              />
              <Services />
            </>
          }
        />
        <Route
          path="/SalonLocation"
          element={
            <>
              <PageMeta
                title="Salon Location & Directions | Priyaa's Beauty Salon, Perambur, Chennai"
                description="Visit Priyaa's Beauty Salon at 29/9, 1st Main Rd, Jawahar Nagar, Perambur, Chennai 600082. Open Mon–Sat 9 AM–8 PM, Sun 10 AM–6 PM. Get directions on Google Maps."
                path="/SalonLocation"
              />
              <SalonLocation />
            </>
          }
        />
        <Route
          path="/contact"
          element={
            <>
              <PageMeta
                title="Contact & Book an Appointment | Priyaa's Beauty Salon, Perambur"
                description="Book your appointment at Priyaa's Beauty Salon, Perambur, Chennai. WhatsApp us or send a message online for hair, bridal makeup, skin care & spa services."
                path="/contact"
              />
              <Contact />
            </>
          }
        />
        <Route
          path="/aboutus"
          element={
            <>
              <PageMeta
                title="About Us | Priyaa's Beauty Salon – Beauty Parlour in Perambur, Chennai"
                description="Priyaa's Beauty Salon has been making Chennai beautiful since 2015. Experienced stylists and beauticians in Jawahar Nagar, Perambur for hair, makeup, skin & spa."
                path="/aboutus"
              />
              <AboutUs />
            </>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
